<template>
  <main>
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1>
          <img src="images/basic/icon/back.svg" onclick="history.back()" class="back" />
          문의하기
        </h1>
      </div>
      <div class="div_padding"></div>
      <form class="body_wrap" @submit.prevent="submitQuiry">
        <div class="el">
          <div class="title">제목</div>
          <input type="text" class="input_box" v-model="nttSj" />
        </div>
        <div class="el textarea_con">
          <div class="title">제휴내용</div>
          <div class="text_area">
            <textarea name="" id="" cols="30" rows="6" v-model="nttCn"></textarea>
            <div class="chat_option">
              <div class="" id="btn_camera">
                <label for="cameraFileInput">
                  <i class="fas fa-camera"></i>
                  <input id="cameraFileInput" type="file" accept="image/*" capture="environment" name="camera_file" style="display: none" ref="camera" @change="cameraInputChange($event)" @click="clearInput($event)" />
                </label>
              </div>
              <div class="album">
                <label for="albumFileInput">
                  <i class="fas fa-image"></i>
                  <input id="albumFileInput" type="file" accept="image/*" name="album_file" style="display: none" @change="albumInputChange($event)" @click="clearInput($event)" />
                </label>
              </div>
              <div class="attach">
                <label for="allFileInput">
                  <i class="fas fa-link"></i>
                  <input id="allFileInput" type="file" name="all_file" style="display: none" @change="allInputChange($event)" @click="clearInput($event)" />
                </label>
              </div>
            </div>
          </div>
          <div class="content">
            <div id="file_list">
              <div v-for="file in fileList" :key="file.name">
                <div class="attached">
                  <a href="#" class="file-name" v-html="file.name"></a>
                  <a href="#" @click="deleteFile(file)"><img src="images/basic/icon/trash-b.svg" alt="" /></a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="el">
          <div class="title">담당자명</div>
          <input type="text" class="input_box" v-model="manager" />
        </div>
        <div class="el">
          <div class="title">연락처</div>
          <input type="tel" class="input_box" v-model="contact" />
        </div>
        <input type="button" value="문의글 남기기" class="submit_btn" @click="submitQuiry" />
      </form>
    </div>

    <div class="overlay">
      <div class="spinner center">
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
        <div class="spinner-blade"></div>
      </div>
    </div>

  </main>
</template>

<script>
import { regProposition } from "@/api/contact";
export default {
  mounted() {
    window.$(document).ready(function () {
      window.$("textarea").focus();
    });
  },
  data() {
    return {
      fileArray: [],
      fileList: [],
      nttSj: "",
      nttCn: "",
      manager: "",
      contact: "",
      requestStart:false
    };
  },
  methods: {
    updateFileList() {
      this.fileList = this.fileArray;
    },
    deleteFile(file) {
      const idx = this.fileArray.findIndex((i) => i.name == file.name);
      this.fileArray.splice(idx, 1);
      this.fileList = this.fileArray;
    },
    submitQuiry() {
      let nttSj = this.nttSj;
      let nttCn = this.nttCn;
      let manager = this.manager;
      let contact = this.contact;
      if (nttSj == undefined || nttSj.trim() == "") {
        alert("제목을 입력해 주세요.");
        return;
      }
      if (nttCn == undefined || nttCn.trim() == "") {
        alert("문의글에 내용을 작성해 주세요.");
        return;
      }
      if (manager == undefined || manager.trim() == "") {
        alert("담당자명을 기입해 주세요.");
        return;
      }
      if (contact == undefined || contact.trim() == "") {
        alert("담당자 연락처를 입력해 주세요.");
        return;
      }
      var frm = new FormData();
      frm.append("nttSj", nttSj);
      frm.append("nttCn", nttCn);
      frm.append("manager", manager);
      frm.append("contact", contact);
      for (let i = 0; i < this.fileArray.length; i++) {
        var fileObj = this.fileArray[i];
        frm.append("file" + i, fileObj.file);
      }
      //frm.append("photo", photoFile.files[0]);
      if(this.requestStart) return;
      this.requestStart = true;

      window.$(".overlay").addClass("on");

      regProposition(frm)
        .then((data) => {
          // 응답 처리
          window.$(".overlay").removeClass("on");
          alert("제휴문의 등록이 완료되었습니다.");
          this.$router.push("/more");
        })
        .catch((error) => {
          window.$(".overlay").removeClass("on");
          console.log(error);
          // 예외 처리
        });
    },
    clearInput(e){
      e.target.value = ''
    },
    cameraInputChange(e) {
      this.pushFile(e);
    },
    albumInputChange(e) {
      this.pushFile(e);
    },
    allInputChange(e) {
      this.pushFile(e);
    },
    pushFile(e) {
      var file = e.target.files[0];
      var fileObj = new Object();
      fileObj.index = this.fileArray.length;
      fileObj.name = file.name;
      fileObj.file = file;

      if(this.fileArray.length > 4){
        alert("파일은 5개 까지만 첨부 가능합니다.");
        return;
      }

      var maxSzie = 200 * 1024 * 1024 // 200mb
      var total_file_size = 0;
      for(var i=0; i<this.fileArray.length ; i++){
        total_file_size += this.fileArray[i].file.size;
      }
      total_file_size += fileObj.file.size;
      if(total_file_size > maxSzie){
        alert("파일은 총 200MB 까지 첨부 가능합니다.");
        return;
      }


      this.fileArray.push(fileObj);
      this.updateFileList();
    },
  },
};
</script>

<style scoped>
.body_wrap {
  padding: 0 30px;
}
.body_wrap .title {
  font-size: 16px;
  font-weight: 900;
  margin-bottom: 10px;
}
.body_wrap .input_box {
  height: 40px;
  width: 100%;
  border-radius: 8px;
  border: 1.5px solid #d8d8d8;
  margin-bottom: 5px;
  color: #252d3a;
}

.text_area {
  width: 100%;
  border-radius: 8px;
  border: 1.5px solid #d8d8d8;
  margin-bottom: 10px;
  padding: 5px;
  color: #252d3a;
}

.text_area textarea {
  width: 100%;
}

.submit_btn {
  width: 100%;
  height: 50px;
  border-radius: 8px;
  color: white;
  background-color: #ff7100;
  border: 1px solid #ff7100;
  margin-top: 5px;
  font-size: 14px;
  font-weight: bolder;
}
</style>
